export interface Driver {
    id: number,
    firstName: string,
    lastName: string,
    dateOfBirth: string,
    hiredOn: string,
    licensedState: string,
    licenseNumber: string,
    yearsDrivingExperience: number,
    termDate: string | null,
    isEditing?: boolean
}
export const DateToConvert = ['dateOfBirth', 'hiredOn', 'termDate'];
export enum IFilter {
    activeDrivers = 'activeDrivers',
    allDrivers = 'allDrivers',
    terminatedDrivers = 'terminatedDrivers'
}
